module.exports = __webpack_public_path__ + "img/spore_circle_1.a552c837.png";